"use strict";

/*
 * Import widget for mainmenu
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var options = {
    $el: null
  };
  var widgetsIds = ["#cargo-widget", "#cart-widget", "#notifications-widget", "#import-widget", "#personalCabinet", "#manager-widget", "#favourite-widget"];
  var timer;
  $.b2b.MainMenuWidgets = {
    open: function open(element) {
      clearTimeout(timer);
      options.$el = $(element);
      widgetsIds.forEach(function (elem) {
        if (element !== elem) $.b2b.MainMenuWidgets.closeAnotherWidget($(elem));
      });
      $.b2b.MainMenuWidgets.openWidget();
    },
    openWidget: function openWidget() {
      options.$el.addClass("open");
    },
    closeWidget: function closeWidget() {
      timer = setTimeout(function () {
        options.$el.removeClass("open");
      }, 500);
    },
    closeAnotherWidget: function closeAnotherWidget(el) {
      el.removeClass("open");
    },
    getWidget: function getWidget(element) {
      return $(element).data('widget');
    }
  };
})(jQuery);